import { get, patch, post } from '../client/client';
import { endpoint } from '../endpoint';
import type {
  PolicyClose,
  PolicyCreate,
  PolicyInterestResponse,
  PolicyPublic,
  PolicyUpdate,
} from '../type/policy';

export const createPolicy = async (payload: PolicyCreate) => {
  return await post<PolicyPublic, PolicyCreate>(endpoint.createPolicy, payload);
};

/** Corrects a policy's card number, nominee or (while unpaid) start month. */
export const updatePolicy = async (policyId: number, payload: PolicyUpdate) => {
  return await patch<PolicyPublic, PolicyUpdate>(endpoint.updatePolicy(policyId), payload);
};

/** Every policy of one member (active, completed and closed). */
export const getMemberPolicies = async (userId: number) => {
  return await get<PolicyPublic[]>(endpoint.getMemberPolicies(userId));
};

export const getPolicy = async (policyId: number) => {
  return await get<PolicyPublic>(endpoint.getPolicy(policyId));
};

export const getPolicyInterest = async (policyId: number) => {
  return await get<PolicyInterestResponse>(endpoint.getPolicyInterest(policyId));
};

export const closePolicy = async (policyId: number, payload: PolicyClose) => {
  return await post<PolicyPublic, PolicyClose>(endpoint.closePolicy(policyId), payload);
};
